import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./Register";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

const apiUrl = `${baseUrl}Registration/ResetPassword`; 

export const ChangePosts1 = createAsyncThunk(
  "posts/fetchPosts",
  async (body) => {
    try {
      const response = await axios.post(apiUrl, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      // Handle errors
      console.error("Error fetching posts:", error);
      throw error;
    }
  }
);

const ChangeSlice1 = createSlice({
  name: "posts",
  initialState,
  reducers: {
    // You can add additional reducers here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(ChangePosts1.pending, (state) => {
        state.status = "loading";
      })
      .addCase(ChangePosts1.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(ChangePosts1.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default ChangeSlice1.reducer;
